import { MoveOutline } from '@lyearn/icons';
import { ActionMenu, ActionMenuItemType } from '@lyearn/molecules';
import { IconButton } from '@lyearn/ui';

import { CategoryActionsEnum, CategoryLayoutView } from '../../../types';

const overrides = {
  PopoverButton: { classes: { closed: 'opacity-0 group-hover:opacity-100', open: 'opacity:100' } },
};

const CategoryActionMenu = ({
  actionMenuItems,
  layoutView,
  onAction,
  className,
  onMouseEnter,
  onMouseLeave,
}: {
  actionMenuItems: ActionMenuItemType[];
  layoutView: CategoryLayoutView;
  onAction: (actionType: CategoryActionsEnum) => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  className?: string;
}) => {
  if (layoutView === 'edit') {
    return (
      <ActionMenu
        items={actionMenuItems}
        minWidth={24}
        overrides={overrides}
        onAction={(actionType) => onAction(actionType as CategoryActionsEnum)}>
        <IconButton
          Icon={MoveOutline}
          aria-label={`drag-handle`}
          className={className}
          shape="square"
          size="s"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </ActionMenu>
    );
  }

  return null;
};

export default CategoryActionMenu;
